const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20adult%20with%20neutral%20expression%2C%20studio%20lighting%2C%20clean%20white%20background%2C%20modern%20editorial%20style&width=100&height=100&seq=avatar-01-91hl&orientation=squarish',
    name: '吃瓜不嫌事大',
    time: '2小时前',
    content: '这个瓜我追了三天了，终于有人把完整时间线整理出来了。建议大家都去看看原帖链接，信息量太大了，每一条都经得起推敲。',
    likes: 1283,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20adult%20female%20with%20confident%20expression%2C%20studio%20lighting%2C%20clean%20white%20background%2C%20modern%20editorial%20style&width=100&height=100&seq=avatar-02-91hl&orientation=squarish',
    name: '真相挖掘机',
    time: '4小时前',
    content: '作为圈内人我必须说一句，这篇文章爆的料至少有一半是真的，但另一半明显被加工过了。不过能曝光出来的已经够震撼了。',
    likes: 967,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20adult%20male%20with%20thoughtful%20expression%2C%20studio%20lighting%2C%20clean%20white%20background%2C%20modern%20editorial%20style&width=100&height=100&seq=avatar-03-91hl&orientation=squarish',
    name: '理中客观察员',
    time: '6小时前',
    content: '我是从微博那边追过来的，这边分析得确实比微博那些断章取义的营销号强太多了。至少每一条都有来源标注，赞一个。',
    likes: 756,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20adult%20female%20with%20friendly%20smile%2C%20studio%20lighting%2C%20clean%20white%20background%2C%20modern%20editorial%20style&width=100&height=100&seq=avatar-04-91hl&orientation=squarish',
    name: '每日一瓜打卡',
    time: '8小时前',
    content: '每天上班第一件事就是打开91黑料网看看有没有新瓜，比刷微博有意思多了，至少这里的信息都是经过核实的。',
    likes: 2041,
  },
];

const mediaItems = [
  {
    id: 1,
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20editorial%20video%20thumbnail%20style%2C%20dark%20background%20with%20a%20single%20focal%20point%20under%20warm%20spotlight%2C%20breaking%20news%20aesthetic%2C%20crimson%20and%20gold%20accents%2C%20professional%20media%20production%20style&width=800&height=450&seq=media-01-91hl&orientation=landscape',
    title: '深度解析：MCN机构背后的资本游戏',
    duration: '15:28',
    tag: '深度专题',
  },
  {
    id: 2,
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20video%20thumbnail%20composition%2C%20split%20screen%20dramatic%20lighting%20with%20warm%20and%20cool%20contrasting%20halves%2C%20investigative%20documentary%20style%2C%20professional%20broadcast%20aesthetic&width=800&height=450&seq=media-02-91hl&orientation=landscape',
    title: '起底直播带货数据造假完整产业链',
    duration: '22:06',
    tag: '调查报道',
  },
  {
    id: 3,
    img: 'https://readdy.ai/api/search-image?query=Editorial%20video%20thumbnail%20with%20layered%20newspaper%20textures%20and%20digital%20glitch%20effects%2C%20warm%20amber%20lighting%2C%20media%20expose%20concept%2C%20professional%20production%20quality&width=800&height=450&seq=media-03-91hl&orientation=landscape',
    title: '2024年度娱乐圈翻车事件大盘点',
    duration: '18:42',
    tag: '年度盘点',
  },
  {
    id: 4,
    img: 'https://readdy.ai/api/search-image?query=Professional%20video%20production%20thumbnail%20style%2C%20dramatic%20interview%20lighting%20setup%20with%20silhouetted%20subject%2C%20anonymous%20source%20concept%2C%20crimson%20and%20charcoal%20tones%2C%20broadcast%20journalism%20aesthetic&width=800&height=450&seq=media-04-91hl&orientation=landscape',
    title: '独家专访：前MCN运营总监现身说法',
    duration: '31:15',
    tag: '独家访谈',
  },
];

export default function SectionsD() {
  return (
    <>
      {/* #comments - 读者评论 */}
      <section id="comments" className="relative py-14 md:py-20 bg-background-100">
        <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950 mb-3">
              吃瓜群众说
            </h2>
            <p className="text-secondary-500 text-sm md:text-base max-w-xl mx-auto">
              来自真实用户的评论与讨论，看看大家都在聊什么
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {comments.map((c, i) => (
              <div key={i} className="bg-background-50 rounded-2xl p-5 md:p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full overflow-hidden shrink-0">
                    <img
                      src={c.avatar}
                      alt={c.name}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div>
                    <div className="font-bold text-sm text-foreground-900">{c.name}</div>
                    <div className="text-xs text-secondary-400">{c.time}</div>
                  </div>
                </div>
                <p className="text-sm text-secondary-600 leading-relaxed mb-4">
                  "{c.content}"
                </p>
                <div className="flex items-center gap-1 text-xs text-secondary-400">
                  <i className="ri-heart-line text-primary-400"></i>
                  <span>{c.likes.toLocaleString()}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* #media - 媒体/视频专区 */}
      <section id="media" className="relative py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
          <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 md:mb-14 gap-4">
            <div>
              <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950 mb-3">
                视频专区
              </h2>
              <p className="text-secondary-500 text-sm md:text-base">
                独家视频专题与深度报道，可视化呈现黑料事件
              </p>
            </div>
            <span className="inline-flex items-center gap-1.5 text-xs text-secondary-400 whitespace-nowrap">
              <i className="ri-play-circle-line text-primary-500"></i>
              共4部专题视频
            </span>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {mediaItems.map((m) => (
              <article
                key={m.id}
                className="group bg-background-100 rounded-2xl overflow-hidden cursor-pointer hover:shadow-lg transition-shadow"
              >
                <div className="relative h-48 md:h-56 overflow-hidden">
                  <img
                    src={m.img}
                    alt={m.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                    <div className="w-14 h-14 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                      <i className="ri-play-fill text-primary-500 text-2xl ml-0.5"></i>
                    </div>
                  </div>
                  <span className="absolute bottom-3 right-3 px-2 py-1 rounded-md bg-black/70 text-white text-xs font-medium whitespace-nowrap">
                    {m.duration}
                  </span>
                </div>
                <div className="p-4">
                  <span className="inline-block px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-[10px] font-bold mb-2 whitespace-nowrap">
                    {m.tag}
                  </span>
                  <h3 className="font-heading font-bold text-sm md:text-base text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">
                    {m.title}
                  </h3>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* #contact - 投稿联系 */}
      <section id="contact" className="relative py-14 md:py-20 bg-background-100">
        <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
          <div className="max-w-3xl mx-auto">
            <div className="bg-background-50 rounded-3xl p-8 md:p-12">
              <div className="text-center mb-8">
                <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-bold mb-4 whitespace-nowrap">
                  投稿联系
                </span>
                <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950 mb-3">
                  有猛料？来投稿
                </h2>
                <p className="text-secondary-500 text-sm md:text-base max-w-lg mx-auto">
                  你的每一次爆料，都可能成为推动行业进步的力量
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
                {[
                  { icon: 'ri-mail-line', title: '投稿邮箱', value: 'tips@91heiliao.com', desc: '附上详细证据材料' },
                  { icon: 'ri-shield-user-line', title: '匿名投稿', value: '完全匿名保护', desc: '采用端到端加密传输' },
                  { icon: 'ri-time-line', title: '响应时效', value: '24小时内回复', desc: '重大爆料优先处理' },
                ].map((c) => (
                  <div key={c.title} className="text-center p-5 rounded-2xl bg-background-100">
                    <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500">
                      <i className={`${c.icon} text-xl`}></i>
                    </div>
                    <div className="font-heading font-bold text-sm text-foreground-900 mb-1">{c.title}</div>
                    <div className="text-sm font-bold text-primary-500 mb-1">{c.value}</div>
                    <div className="text-xs text-secondary-400">{c.desc}</div>
                  </div>
                ))}
              </div>

              <div className="text-center">
                <p className="text-sm text-secondary-400 mb-4">
                  我们承诺：严格保护爆料人隐私，绝不泄露任何个人信息
                </p>
                <a
                  href="mailto:tips@91heiliao.com"
                  className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white font-bold text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
                >
                  <i className="ri-send-plane-line text-lg"></i>
                  立即投稿爆料
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}